export const en = (__LOCALE_EN__ ? ({
  titles: {
    quantity_cards: 'Cards in list: {{count}}',
    quantity_faces: 'Faces in list: {{count}}',
    tabs: {
      cards: 'Cards',
      faces: 'Faces without cards',
    },
  },
  'info block': {
    title: 'General information',
    name: 'Title',
    'owner department': 'Owner department',
    created: 'Created',
    'last changes': 'Last changes',
  },
  'edit list': {
    title: 'Edit list',
    'input label': 'List name',
    toast: {
      success: 'The list has been edited successfully',
    },
  },
  delete_modal: {
    title: 'Delete list(s)',
    subtitle: 'Choose what to do with faces in the selected list(s)',
    options: {
      with_faces: 'Delete faces',
      without_faces: 'Keep faces (detach only)',
    },
    actions: {
      delete: 'Delete list',
      cancel: 'Cancel',
    },
    toast: {
      success: 'List was successfully deleted.',
    },
  },
  filters: {
    buttons: {
      'reset button': 'Reset',
    },
    popovers: {
      face_ids: 'Face ID',
      user_data: 'User data',
      date: 'Date created',
      'external id': 'Card ID',
      fio: 'Full name',
      lists: 'Lists',
    },
  },
  sort: {
    dropdown_options: {
      date_desc: 'By creation date (newest first)',
      date_asc: 'By creation date (oldest first)',
      user_data_asc: 'By user data field (A to Z)',
      user_data_desc: 'By user data field (Z to A)',
      fio_asc: 'By full name (A to Z)',
      fio_desc: 'By full name (Z to A)',
    },
  },
  list_cards_actions: {
    create_card_label: 'Card',
  },
  list_faces_actions: {
    create_face_label: 'Face',
    export: 'Export',
    import: 'Import',
  },
  cards_bulk_actions: {
    selected_count: 'Selected: {{count}}',
    delete: 'Delete',
    add_to_list: 'Add to list',
    replace: 'Replace',
    remove_from_list: 'Remove from list',
  },
}) : {}) as Record<string, unknown>;
export const ru = (__LOCALE_RU__ ? ({
  titles: {
    quantity_cards: 'Карточек в списке: {{count}}',
    quantity_faces: 'Лиц в списке: {{count}}',
    tabs: {
      cards: 'Карточки',
      faces: 'Лица без карточек',
    },
  },
  'info block': {
    title: 'Общая информация',
    name: 'Название',
    'owner department': 'Подразделение владелец',
    created: 'Создан',
    'last changes': 'Последние изменения',
  },
  'edit list': {
    title: 'Редактировать список',
    'input label': 'Название',
    toast: {
      success: 'Список успешно отредактирован',
    },
  },
  delete_modal: {
    title: 'Удалить список(и)',
    subtitle: 'Выберите, что сделать с лицами в списке(ах)',
    options: {
      with_faces: 'Удалить лица',
      without_faces: 'Не удалять лица (только открепить)',
    },
    actions: {
      delete: 'Удалить список',
      cancel: 'Отмена',
    },
    toast: {
      success: 'Список успешно удален.',
    },
  },
  filters: {
    buttons: {
      'reset button': 'Очистить',
    },
    popovers: {
      face_ids: 'ID лица',
      user_data: 'Информация',
      date: 'Дата создания',
      'external id': 'ID карточки',
      fio: 'ФИО',
      lists: 'Списки',
    },
  },
  sort: {
    dropdown_options: {
      date_asc: 'По дате создания (сначала новые)',
      date_desc: 'По дате создания (сначала старые)',
      user_data_asc: 'По полю Информация (от А до Я)',
      user_data_desc: 'По полю Информация (от Я до А)',
      fio_asc: 'По ФИО (от А до Я)',
      fio_desc: 'По ФИО (от Я до А)',
    },
  },
  list_cards_actions: {
    create_card_label: 'Карточка',
  },
  list_faces_actions: {
    create_face_label: 'Лицо',
    export: 'Экспорт',
    import: 'Импорт',
  },
  cards_bulk_actions: {
    selected_count: 'Выбрано: {{count}}',
    delete: 'Удалить',
    add_to_list: 'Добавить в список',
    replace: 'Перенести',
    remove_from_list: 'Исключить из списка',
  },
}) : {}) as Record<string, unknown>;
